import { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Input } from "antd";
import { AuthContext } from "../../../Contexts/AuthContext";
import styles from "../ShippingAddressScreen.module.scss";

export const AdditionalInformation = ({ form }) => {
  const { user } = useContext(AuthContext);
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem("additional")) {
      setInitialValues(JSON.parse(sessionStorage.getItem("additional")));
    } else {
      setInitialValues({
        additional_info_1: user.additional_info_1,
        additional_info_2: user.additional_info_2,
      });
    }
  }, []);

  if (!initialValues) return null;

  return (
    <Form
      className={styles.shipping_form_v2}
      style={{ width: "100%" }}
      form={form}
      initialValues={initialValues}
      layout={"vertical"}
    >
      <Row style={{ width: "100%", marginTop: "1.5rem" }} gutter={[16, 0]}>
        <Col lg={12} xs={24}>
          <Form.Item name={"additional_info_1"}>
            <Input placeholder={"Name on nameplate/bell/Floor Nr"} />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item name={"additional_info_2"}>
            <Input placeholder={"Landmark"} />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24} style={{ marginBottom: "2rem" }}>
          <span style={{ color: "var(--color-grey)" }}>
            Additional information help us deliver preciously at your doorsteps.
          </span>
        </Col>
      </Row>
    </Form>
  );
};
